import postalCodes from 'postal-codes-js';

export const isValidPostalCode = (countryCode: string | null, postCode: string | null ) => {
    if ( !countryCode || !postCode ) return false;

    return postalCodes.validate(countryCode, postCode) === true;
};